import { format, parse, parseISO, isValid } from 'date-fns'

export const formatBirthDate = (birthDate?: string): string => {
  if (!birthDate) return ''

  let parsedDate = parseISO(birthDate)
  if (!isValid(parsedDate)) {
    parsedDate = parse(birthDate, 'dd/MM/yyyy', new Date())
  }

  if (!isValid(parsedDate)) return ''

  return format(parsedDate, 'dd/MM/yyyy')
}
